export const onlineOrderModificationAction= (data) => { 
    return {
       type: data.type,
       data:data.data
    }
 }